(() => {
  if (window.icconxCatalogReady) return;
  window.icconxCatalogReady = true;

  let selected, activeProduct, trigger;
  const modal = () => document.getElementById("IxQuickBuy");
  const money = amount =>
    new Intl.NumberFormat("en-IN", {
      style: "currency",
      currency: window.Shopify?.currency?.active || "INR",
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
    }).format(amount / 100);
  const el = id => document.getElementById(id);

  function ensureButtonStructure(btn) {
    if (!btn) return;
    if (!btn.querySelector(".loader-button__text")) {
      const currentText = btn.textContent.trim() || "Add To Cart";
      btn.innerHTML =
        '<span class="loader-button__text">' +
        currentText +
        '</span><span class="loader-button__loader" hidden aria-hidden="true"><div class="spinner"><svg focusable="false" width="22" height="22" class="icon icon--spinner" viewBox="25 25 50 50"><circle cx="50" cy="50" r="20" fill="none" stroke="currentColor" stroke-width="4.5" stroke-linecap="round"></circle></svg></div></span>';
    }
  }

  function updateVariant(variant) {
    selected = variant;
    const p = activeProduct.product;
    const img = variant.featured_image?.src || p.featured_image;
    el("IxQuickImage").src = img || "";
    el("IxQuickImage").alt = activeProduct.title + " — " + variant.title;
    el("IxQuickPrice").replaceChildren();
    const strong = document.createElement("strong");
    strong.textContent = money(variant.price);
    el("IxQuickPrice").append(strong);
    if (variant.compare_at_price > variant.price) {
      const del = document.createElement("del");
      del.textContent = money(variant.compare_at_price);
      el("IxQuickPrice").append(del);
      const off = document.createElement("span");
      off.className = "ix-quick-discount";
      off.textContent =
        Math.round((1 - variant.price / variant.compare_at_price) * 100) + "% Off";
      el("IxQuickPrice").append(off);
    }

    const addBtn = el("IxQuickAdd");
    if (addBtn) {
      ensureButtonStructure(addBtn);
      addBtn.disabled = false;
      addBtn.classList.remove("is-loading");
      addBtn.removeAttribute("aria-busy");
      const loader = addBtn.querySelector(".loader-button__loader");
      if (loader) loader.setAttribute("hidden", "");
      const textSpan = addBtn.querySelector(".loader-button__text");
      if (textSpan) {
        textSpan.textContent = variant.available ? "Add To Cart" : "Notify Me";
      }
    }

    el("IxQuickLink").href =
      (window.Shopify?.routes?.root || "/") +
      "products/" +
      p.handle +
      "?variant=" +
      variant.id;
    el("IxQuickError").textContent = "";
    if (el("IxSelectedColor")) el("IxSelectedColor").textContent = variant.title;
    el("IxQuickOptions")
      .querySelectorAll("button")
      .forEach(b =>
        b.setAttribute("aria-pressed", String(b.dataset.variant === String(variant.id)))
      );
  }

  function openProduct(button) {
    const json = el("ix-product-" + button.dataset.ixQuickBuy);
    if (!json || !modal()) return;
    activeProduct = JSON.parse(json.textContent);
    trigger = button;
    el("IxQuickTitle").textContent = activeProduct.title;
    el("IxQuickFeatures").replaceChildren(
      ...activeProduct.features.filter(Boolean).map(s => {
        const li = document.createElement("li");
        li.textContent = s;
        return li;
      })
    );
    el("IxQuickOptions").replaceChildren();
    if (activeProduct.product.variants.length > 1) {
      const label = document.createElement("p");
      const bold = document.createElement("strong");
      bold.textContent = "Choose your color : ";
      const value = document.createElement("span");
      value.id = "IxSelectedColor";
      label.append(bold, value);
      el("IxQuickOptions").append(label);
      activeProduct.product.variants.forEach(v => {
        const b = document.createElement("button");
        b.type = "button";
        b.setAttribute("aria-label", v.title + (v.available ? "" : " — Sold out"));
        b.title = v.title + (v.available ? "" : " — Sold out");
        const src = v.featured_image?.src;
        if (src) {
          const thumb = document.createElement("img");
          thumb.src = src;
          thumb.alt = v.title;
          thumb.width = 36;
          thumb.height = 36;
          b.append(thumb);
        } else {
          b.textContent = v.title;
        }
        b.dataset.variant = v.id;
        b.onclick = () => updateVariant(v);
        el("IxQuickOptions").append(b);
      });
    }
    const initialVariant =
      activeProduct.product.variants.find(
        v => String(v.id) === button.dataset.variantId
      ) ||
      activeProduct.product.variants.find(v => v.available) ||
      activeProduct.product.variants[0];
    updateVariant(initialVariant);
    modal().classList.remove("ix-leaving");
    modal().showModal();
    modal().animate(
      [
        { transform: "translateX(100vw)", opacity: 0 },
        { transform: "translateX(0)", opacity: 1 }
      ],
      {
        duration: matchMedia("(prefers-reduced-motion: reduce)").matches ? 0 : 600,
        easing: "cubic-bezier(.75,0,.175,1)"
      }
    );
    document.documentElement.classList.add("ix-modal-open");
  }

  let closing;
  async function close() {
    if (!modal()?.open) return;
    if (closing) return closing;
    closing = (async () => {
      await modal().animate(
        [
          { transform: "translateX(0)", opacity: 1 },
          { transform: "translateX(100vw)", opacity: 0 }
        ],
        {
          duration: matchMedia("(prefers-reduced-motion: reduce)").matches ? 0 : 600,
          easing: "cubic-bezier(.75,0,.175,1)"
        }
      ).finished;
      modal().close();
      document.documentElement.classList.remove("ix-modal-open");
      trigger?.focus();
    })();
    await closing;
    closing = null;
  }

  document.addEventListener("click", async event => {
    const quick = event.target.closest("[data-ix-quick-buy]");
    if (quick) {
      event.preventDefault();
      openProduct(quick);
      return;
    }
    if (event.target.closest(".ix-quick-close")) {
      close();
      return;
    }
    if (event.target === modal()) {
      const r = modal().getBoundingClientRect();
      if (
        event.clientX < r.left ||
        event.clientX > r.right ||
        event.clientY < r.top ||
        event.clientY > r.bottom
      )
        close();
      return;
    }
    if (event.target.closest("#IxQuickAdd")) {
      if (!selected?.available) {
        const prod = activeProduct?.product;
        const vId = selected?.id;
        await close();
        if (false) {
          window.openIxNotifyModal(prod, vId);
        }
        return;
      }
      const button = el("IxQuickAdd");
      if (!button || button.disabled || button.classList.contains("is-loading"))
        return;

      ensureButtonStructure(button);

      // Trigger custom smooth animated spinner loader
      button.disabled = true;
      button.setAttribute("aria-busy", "true");
      button.classList.add("is-loading");
      const loader = button.querySelector(".loader-button__loader");
      if (loader) loader.removeAttribute("hidden");

      try {
        const root = window.Shopify?.routes?.root || "/";
        const response = await fetch(root + "cart/add.js", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Accept: "application/json"
          },
          body: JSON.stringify({ items: [{ id: selected.id, quantity: 1 }] })
        });
        const result = await response.json();
        if (!response.ok)
          throw new Error(
            result.description ||
              "This option could not be added. Please try another."
          );

        await close();
        const cartResponse = await fetch(root + "cart.js");
        if (cartResponse.ok)
          document.dispatchEvent(
            new CustomEvent("cart:updated", {
              detail: { cart: await cartResponse.json() }
            })
          );
        const drawer = document.getElementById("CartDrawer");
        if (drawer)
          document.dispatchEvent(
            new CustomEvent("cart:refresh", { detail: { open: true } })
          );
        else window.location.assign(root + "cart");
      } catch (error) {
        el("IxQuickError").textContent = error.message;
      } finally {
        if (button) {
          button.classList.remove("is-loading");
          button.removeAttribute("aria-busy");
          const ldr = button.querySelector(".loader-button__loader");
          if (ldr) ldr.setAttribute("hidden", "");
          button.disabled = !selected?.available;
          const txt = button.querySelector(".loader-button__text");
          if (txt) {
            txt.textContent = selected?.available ? "Add To Cart" : "Sold Out";
          }
        }
      }
      return;
    }
    const sort = event.target.closest("#IxSortBtn") || event.target.closest("#IcconxSortBtn");
    if (sort) {
      const menu = el("IxSortMenu") || el("IcconxSortMenu");
      menu.hidden = !menu.hidden;
      sort.setAttribute("aria-expanded", String(!menu.hidden));
      return;
    }
    const option = event.target.closest(".ix-sort-option") || event.target.closest(".icconx-sort-option");
    if (option) {
      const url = new URL(location.href);
      url.searchParams.set("sort_by", option.dataset.value);
      url.searchParams.delete("page");
      location.assign(url);
      return;
    }
    if (event.target.closest("#IxFilterTrigger") || event.target.closest("#IcconxFilterTrigger")) {
      document.getElementById("FacetDrawer")?.show();
      return;
    }
    if (event.target.closest("[data-facet-close], .ix-facet-close-btn, .button--close")) {
      const drawer = document.getElementById("FacetDrawer");
      if (drawer) {
        if (typeof drawer.hide === "function") drawer.hide();
        else drawer.removeAttribute("open");
      }
      return;
    }
    if (event.target.closest("overlay-element[aria-controls='FacetDrawer']")) {
      const drawer = document.getElementById("FacetDrawer");
      if (drawer) {
        if (typeof drawer.hide === "function") drawer.hide();
        else drawer.removeAttribute("open");
      }
      return;
    }
    const curMenu = el("IxSortMenu") || el("IcconxSortMenu");
      const curBtn = el("IxSortBtn") || el("IcconxSortBtn");
      if (!event.target.closest("#IxSortWrap") && !event.target.closest("#IcconxSortWrap") && curMenu) {
      if (curMenu) curMenu.hidden = true; if (curBtn) curBtn.setAttribute("aria-expanded", "false");
    }
  });

  document.addEventListener(
    "cancel",
    e => {
      if (e.target.id === "IxQuickBuy") {
        e.preventDefault();
        close();
      }
    },
    true
  );

  function updateDisplayedCount() {
    const count = document.querySelectorAll(".icconx-product-grid > .icconx-product-card").length;
    const label = document.querySelector("[data-icconx-result-count]");
    if (label && count) label.textContent = count + (count === 1 ? " model" : " models");
  }

  updateDisplayedCount();
  document.addEventListener(
    "close",
    e => {
      if (e.target.id === "IxQuickBuy")
        document.documentElement.classList.remove("ix-modal-open");
    },
    true
  );

  // ICCONX Color Swatch Interaction on Product Cards
  document.addEventListener("click", (e) => {
    const swatch = e.target.closest(".ix-swatch-dot");
    if (swatch) {
      e.preventDefault();
      e.stopPropagation();
      const card = swatch.closest(".ix-product-card");
      if (!card) return;
      const newImg = swatch.getAttribute("data-img");
      const vId = swatch.getAttribute("data-variant-id");
      if (newImg) {
        const img = card.querySelector(".ix-card-img");
        if (img) img.src = newImg;
      }
      if (vId) {
        const atc = card.querySelector(".ix-add-to-cart-btn");
        if (atc) atc.setAttribute("data-variant-id", vId);
      }
      card.querySelectorAll(".ix-swatch-dot").forEach(s => s.classList.remove("is-active"));
      swatch.classList.add("is-active");
    }
  });

  document.addEventListener("mouseover", (e) => {
    const swatch = e.target.closest(".ix-swatch-dot");
    if (swatch) {
      const card = swatch.closest(".ix-product-card");
      if (!card) return;
      const newImg = swatch.getAttribute("data-img");
      if (newImg) {
        const img = card.querySelector(".ix-card-img");
        if (img) img.src = newImg;
      }
    }
  });

})();
